// Module
var code = "<p>תוכלו לשנות את פרטי החשבון שלכם באמצעות לחיצה על לחצן ה”חשבון&quot; בעמוד הבית.</p> ";
// Exports
export default code;